import { Button, Form, FormInstance, Input, Modal, Space } from "antd";
import React, { useEffect } from "react";
import {
  CreateHallPayload,
  GetHallFloorPayload,
  UpdateHallFloorPayload,
  UpdateHallPayload,
} from "../../interfaces";
import TextArea from "antd/lib/input/TextArea";
import { useDispatch } from "react-redux";
import { appSelector } from "../../helpers/appSelector";
import { ModalSpinner, Spinner } from "../common/Spinner";
import { getHallFloor } from "../../store/hallFloors";

interface Props {
  open: boolean;
  onCancel: () => void;
  form: FormInstance<UpdateHallFloorPayload>;
  onFinish: ((values: UpdateHallFloorPayload) => void) | undefined;
  id: string;
  hallId?: string | number;
}

const UpdateHallFloorForm = ({
  open,
  onCancel,
  form,
  onFinish,
  id,
  hallId,
}: Props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const payload: GetHallFloorPayload = {
      id: id,
      hallId: hallId as string,
    };
    id && dispatch(getHallFloor(payload));
  }, [dispatch, id]);

  const {
    floor,
    loading: loadingHallFloor,
    isHallFloorSubmitting,
    success,
  } = appSelector((state) => state.hallFloorStore);

  useEffect(() => {
    success && onCancel();
  }, [success]);

  const initialValues: UpdateHallFloorPayload = {
    name: floor?.name || "",
    description: floor?.description || "",
    hall_id: hallId?.toString() || "",
    id: floor?.id || "",
  };

  form.setFieldsValue(initialValues);

  return (
    <Modal
      title="Update Floor"
      open={open}
      onCancel={onCancel}
      footer={[
        <Button type="default" key="cancel" onClick={() => onCancel()}>
          Close
        </Button>,
        <Button
          form="hallUpdateForm"
          key="submit"
          htmlType="submit"
          type="primary"
          loading={isHallFloorSubmitting}
        >
          {isHallFloorSubmitting ? "Updating.." : "Update"}
        </Button>,
      ]}
    >
      <Form<UpdateHallFloorPayload>
        form={form}
        layout="vertical"
        id="hallUpdateForm"
        name="hallUpdateForm"
        initialValues={initialValues}
        onFinish={onFinish}
      >
        {loadingHallFloor ? (
          <ModalSpinner />
        ) : (
          <>
            <Form.Item
              name="name"
              label="Hall Name"
              rules={[
                {
                  required: true,
                  message: "Please input the name of the floor!",
                },
              ]}
            >
              <Input type="text" />
            </Form.Item>
            <Form.Item name="contact" label="Contact">
              <Input maxLength={10} showCount type="tel" />
            </Form.Item>
            <Form.Item name="description">
              <TextArea allowClear rows={5} />
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default UpdateHallFloorForm;
